module.exports = __webpack_public_path__ + "img/put-active.d713d622.svg";